import styled, { css } from 'styled-components';
import type { Severity } from '@entities/compliance/types';

interface Props {
  $severity?: Severity;
  $tone?: 'neutral' | 'success' | 'warning' | 'danger' | 'info';
}

export const Badge = styled.span<Props>`
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: ${({ theme }) => theme.radius.pill};
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
  line-height: 1.4;

  ${({ $severity, $tone, theme }) => {
    if ($severity) {
      switch ($severity) {
        case 'critical':
          return css`
            background: ${theme.colors.status.danger};
            color: #fff;
          `;
        case 'major':
          return css`
            background: ${theme.colors.status.warning};
            color: #fff;
          `;
        case 'minor':
          return css`
            background: ${theme.colors.status.info};
            color: #fff;
          `;
        case 'info':
          return css`
            background: ${theme.colors.surface};
            color: ${theme.colors.text.secondary};
            border: 1px solid ${theme.colors.border};
          `;
      }
    }
    switch ($tone) {
      case 'success':
        return css`
          background: ${theme.colors.status.success}1A;
          color: ${theme.colors.status.success};
          border: 1px solid ${theme.colors.status.success}33;
        `;
      case 'warning':
        return css`
          background: ${theme.colors.status.warning}1A;
          color: ${theme.colors.status.warning};
          border: 1px solid ${theme.colors.status.warning}33;
        `;
      case 'danger':
        return css`
          background: ${theme.colors.status.danger}1A;
          color: ${theme.colors.status.danger};
          border: 1px solid ${theme.colors.status.danger}33;
        `;
      case 'info':
        return css`
          background: ${theme.colors.status.info}1A;
          color: ${theme.colors.status.info};
          border: 1px solid ${theme.colors.status.info}33;
        `;
      default:
        return css`
          background: ${theme.colors.surface};
          color: ${theme.colors.text.secondary};
          border: 1px solid ${theme.colors.border};
        `;
    }
  }}
`;
